import React, { useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { CONFIG } from '../config';
export function OfferModule() {
  const [selectedPlan, setSelectedPlan] = useState<'completa' | 'esencial'>('completa');
  const handlePurchase = () => {
    const url = selectedPlan === 'completa' ? CONFIG.CHECKOUT_LINK_COMPLETA : CONFIG.CHECKOUT_LINK_ESENCIAL;
    window.location.href = url;
  };
  return <div className="max-w-2xl mx-auto w-full" id="oferta" data-id="element-156">
      <div className="grid gap-3 mb-5 mt-3" data-id="element-157">
        {/* Plan Completa */}
        <button type="button" onClick={() => setSelectedPlan('completa')} aria-pressed={selectedPlan === 'completa'} className={`relative text-left cursor-pointer rounded-xl border-2 p-4 transition-all ${selectedPlan === 'completa' ? 'bg-white border-gold shadow-lg' : 'bg-white/60 border-transparent hover:bg-white/80'}`} data-id="element-158">
          {selectedPlan === 'completa' && <div className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-gold text-white text-[10px] font-bold px-3 py-0.5 rounded-full uppercase tracking-wider whitespace-nowrap" data-id="element-159">
              ⭐ El más elegido
            </div>}
          <div className="flex items-center justify-between gap-3" data-id="element-160">
            <div className="flex items-center gap-3 min-w-0" data-id="element-161">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${selectedPlan === 'completa' ? 'border-gold bg-gold' : 'border-brown/20'}`} data-id="element-162">
                {selectedPlan === 'completa' && <div className="w-2 h-2 bg-white rounded-full" data-id="element-163" />}
              </div>
              <h3 className="font-serif text-lg md:text-xl font-bold text-brown truncate" data-id="element-164">
                Transformación Completa
              </h3>
            </div>
            <p className="font-sans text-gold font-bold text-lg md:text-xl shrink-0" data-id="element-165">
              $25.990
            </p>
          </div>
          <ul className="mt-2 pl-8 space-y-0.5 font-sans text-xs text-brown/70" data-id="element-166">
            <li className="flex items-start gap-1.5" data-id="element-167">
              <CheckCircle2 className="w-3.5 h-3.5 text-gold shrink-0 mt-0.5" data-id="element-168" />{' '}
              3 Tomos completos
            </li>
            <li className="flex items-start gap-1.5" data-id="element-169">
              <CheckCircle2 className="w-3.5 h-3.5 text-gold shrink-0 mt-0.5" data-id="element-170" />{' '}
              Los 6 bonos completos
            </li>
            <li className="flex items-start gap-1.5" data-id="element-171">
              <CheckCircle2 className="w-3.5 h-3.5 text-gold shrink-0 mt-0.5" data-id="element-172" />{' '}
              El sistema completo para sostener el cambio
            </li>
          </ul>
        </button>

        {/* Plan Esencial */}
        <button type="button" onClick={() => setSelectedPlan('esencial')} aria-pressed={selectedPlan === 'esencial'} className={`text-left cursor-pointer rounded-xl border-2 p-4 transition-all ${selectedPlan === 'esencial' ? 'bg-white border-gold shadow-lg' : 'bg-white/60 border-transparent hover:bg-white/80'}`} data-id="element-173">
          <div className="flex items-center justify-between gap-3" data-id="element-174">
            <div className="flex items-center gap-3 min-w-0" data-id="element-175">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${selectedPlan === 'esencial' ? 'border-gold bg-gold' : 'border-brown/20'}`} data-id="element-176">
                {selectedPlan === 'esencial' && <div className="w-2 h-2 bg-white rounded-full" data-id="element-177" />}
              </div>
              <h3 className="font-serif text-lg md:text-xl font-bold text-brown/80 truncate" data-id="element-178">
                Plan Esencial
              </h3>
            </div>
            <p className="font-sans text-brown/60 font-bold text-lg md:text-xl shrink-0" data-id="element-179">
              $19.990
            </p>
          </div>
          <ul className="mt-2 pl-8 space-y-0.5 font-sans text-xs text-brown/60" data-id="element-180">
            <li className="flex items-start gap-1.5" data-id="element-181">
              <CheckCircle2 className="w-3.5 h-3.5 text-brown/40 shrink-0 mt-0.5" data-id="element-182" />{' '}
              Tomo 1: Hackeá tu Realidad (100 frases)
            </li>
            <li className="flex items-start gap-1.5" data-id="element-183">
              <CheckCircle2 className="w-3.5 h-3.5 text-brown/40 shrink-0 mt-0.5" data-id="element-184" />{' '}
              Los 6 bonos completos
            </li>
            <li className="flex items-start gap-1.5" data-id="element-185">
              <CheckCircle2 className="w-3.5 h-3.5 text-brown/40 shrink-0 mt-0.5" data-id="element-186" />{' '}
              Descarga inmediata
            </li>
          </ul>
        </button>
      </div>

      <button onClick={handlePurchase} className="w-full py-4 bg-gold hover:bg-gold-600 text-white font-sans font-bold text-lg md:text-xl rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 mb-4 flex items-center justify-center gap-2" data-id="element-187">
        OBTENER ACCESO AHORA →
      </button>

      <div className="text-center bg-gold/10 p-3 rounded-xl border border-gold/20" data-id="element-188">
        <p className="font-sans text-xs md:text-sm font-medium text-[#ACA49C]" data-id="element-189">
          Por solo <strong className="text-gold" data-id="element-190">$6.000 más</strong> te llevás
          los 2 tomos que convierten las frases en un cambio real y duradero. Es
          lo que elige la mayoría.
        </p>
      </div>
    </div>;
}